import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  step: 'selection',
  productNumber: '',
  preActivatedSim: false,
  successfulOrdered: false,
  orderId: '',
  statusSimType: null,
  activationType: 'PREACTIVATED',
  selectionData: {
    simType: null,
    activation: null,
    productNumber: null
  },
  substituteSimCardOptions: [
    {
      possibleActivationSettings: [],
      price: '0',
      productNumber: null,
      productPrice: 0,
      shippingCosts: 0,
      total: 0,
      type: null
    }
  ],
  view: 'substituteSim',
  skippedSelection: false,
  eSimInstalled: false,
  simCardType: ''
}
const ESIM = 'E_SIM'

const SubstituteSimCardModule = {
  namespaced: true,
  state: initialState,
  actions: {
    // TODO: remove after new Substitute Process (with eSIM) is implemented
    async orderSubstituteSimCard ({ commit, state, getters, rootGetters }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation orderSubstituteSim ($substituteSimCardInput: SubstituteSimCardInput!) {
          substituteSimCard (substituteSimCardInput: $substituteSimCardInput) {
            success
          }
        }`,
        variables: {
          substituteSimCardInput: {
            substituteSimCardProcess: 'MAGMA',
            productNumber: state.productNumber,
            activateByCustomer: !state.preActivatedSim
          }
        }
      }).then((result) => {
        commit('Transaction/removeTransactionId', 'substituteSimCard', { root: true })
        return result.data.substituteSimCard.success
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    },
    async orderSubstituteESimCard ({ commit, state, getters, rootGetters }) {
      const productNumber = state.selectionData.productNumber
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation orderSubstituteSim ($substituteSimCardInput: SubstituteSimCardInput!) {
          substituteSimCard (substituteSimCardInput: $substituteSimCardInput) {
            success
          }
        }`,
        variables: {
          substituteSimCardInput: {
            productNumber: productNumber,
            activateByCustomer: !state.preActivatedSim,
            substituteSimCardProcess: 'MAGMA'
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'substituteESimCard', { root: true })
        // we don't get an order id from magme here, so we generate a unique random hash here, because for tracking it's mandatory'
        const uuid = require('uuid')
        response.data.substituteSimCard.orderHash = uuid.v1()
        return response.data.substituteSimCard
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    },
    async activateSim ({ commit, state, getters, rootGetters }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation activateSimCard {
          activateSubstituteSimCard{success}
        }`
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'substituteSimCard', { root: true })
        return response.data.activateSubstituteSimCard.success
      }).catch((error) => {
        splitError(error).forEach(e => {
          commit('addError', e, { root: true })
        })
        return false
      })
    },
    resetSimDefaultState ({ commit, state }) {
      commit('resetState', state)
    }
  },
  mutations: {
    changeStep (state, step) {
      state.step = step
    },
    setActivationService (state, serviceOrder) {
      state.preActivatedSim = serviceOrder
    },
    setProductNumber (state, productNumber) {
      state.productNumber = productNumber
    },
    setOrderStatus (state, status) {
      state.successfulOrdered = status
    },
    setOrderId (state, status) {
      state.orderId = status
    },
    setStatusSimType (state, simType) {
      state.statusSimType = simType
    },
    setSubstituteSimCardOptions (state, substituteSimCardOptions) {
      state.substituteSimCardOptions = substituteSimCardOptions
    },
    setSelectedActivationType (state, activationType) {
      state.activationType = activationType
    },
    setSelectionData (state, data) {
      state.selectionData.simType = data.simType
      if (data.simType === ESIM) {
        state.selectionData.activation = 'PREACTIVATED'
      } else {
        state.selectionData.activation = data.activation
      }
    },
    setStep (state, step) {
      if (typeof step !== 'undefined' && step !== null) {
        state.view = step
      }
    },
    setSelectedProductNumber (state, productNumber) {
      state.selectionData.productNumber = productNumber
    },
    setSkippedSelection (state) {
      state.skippedSelection = true
    },
    setEsimInstalled (state, esimInstalled) {
      state.eSimInstalled = esimInstalled
    },
    setSimCardType (state, simCardType) {
      state.simCardType = simCardType
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  },
  getters: {
    currentStep: state => state.step,
    selected: state => state.selectedOption,
    isPreActivated: state => state.preActivatedSim,
    wasSuccess: state => state.successfulOrdered,
    skippedSelection: state => state.skippedSelection,
    eSimInstalled: state => state.eSimInstalled,
    simCardType: state => state.simCardType,
    getStatusSimType (state) {
      return state.statusSimType
    },
    getSimCardOption (state) {
      const simCard = state.substituteSimCardOptions.filter(el => el.type === state.statusSimType)
      if (simCard[0]) {
        return simCard[0]
      } else {
        return initialState.substituteSimCardOptions[0]
      }
    },
    isEsim (state, getters) {
      return getters.getSimCardOption?.type === ESIM
    },
    isFreeEsim (state, getters) {
      return getters.getSimCardOption?.type === ESIM && getters.getSimCardOption?.productPrice === 0
    },
    getActivationType (state) {
      return state.activationType
    },
    getSelectionData (state) {
      return state.selectionData
    },
    getOrderId (state) {
      return state.orderId
    },
    showCheckoutView: state => {
      return state.view
    }
  }
}

export {
  SubstituteSimCardModule
}
